import React, { useEffect } from 'react';
import './popup.css';

interface ReactFunPopupContent {
  closePopupFunction: () => void;
}

const Popup: React.FC<{
  isOpen: boolean;
  onClose: () => void;
  PopupContent: React.FC<ReactFunPopupContent>;
}> = ({ isOpen, onClose, PopupContent }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.classList.add('popup-open');
    }
  }, [isOpen]);

  const closePopup = (): void => {
    document.body.classList.remove('popup-open');
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="popup-overlay" onClick={onClose} role="presentation">
      <div
        className="popup-content"
        onClick={(e) => e.stopPropagation()}
        role="presentation"
      >
        <div id="popup-close-container" className="popup-close-container">
          <button className="close-popup-button" onClick={closePopup} />
        </div>
        <PopupContent closePopupFunction={closePopup} />
      </div>
    </div>
  );
};

export default Popup;
